import { render, staticRenderFns } from "./professorOff.vue?vue&type=template&id=4b8a968e&scoped=true"
import script from "./professorOff.vue?vue&type=script&lang=js"
export * from "./professorOff.vue?vue&type=script&lang=js"
import style0 from "./professorOff.vue?vue&type=style&index=0&id=4b8a968e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a968e",
  null
  
)

export default component.exports